/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
export class Modal extends Component {

  static propTypes = {
    modalId: PropTypes.any
  }
  constructor(props) {
    super(props);
    this.state = {
      modalId: uuidv4(),
      isOpen: false
    };
  }

  componentDidMount() {
    if (this.props.modalId) {
      this.setState({ modalId: this.props.modalId });
    }
  }

  componentWillReceiveProps(nextProps) {

    if (typeof (nextProps.isOpen) !== 'undefined') {
      if (nextProps.isOpen === true) {
        $('#' + this.state.modalId).modal({ show: 'false', backdrop: 'static', keyboard: false });
      } else {
        $('#' + this.state.modalId).modal('hide');
      }
    }
  }

  render() {
    return <div className='modal fade in' id={this.state.modalId} role='dialog'>
      <div className='modal-dialog'>
        <div className='modal-content'>
          {this.props.children}
        </div>
      </div>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/modal/modal.js